import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/New-York.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Driving Digital Excellence in New York's Software Development
              Landscape
            </h2>
            <p>
              Standing among New York's top software development companies,
              TekRevol boasts unmatched proficiency in software development. Our
              commitment to excellence extends to groundbreaking innovations and
              exclusive functionalities, underpinned by industry-leading coding
              practices. Our dedicated client support, together with cloud-based
              hosting solutions, ensures a flawless digital journey.
            </p>
            <p>
              With a solid foothold in New York City, we push businesses toward
              success through groundbreaking digital solutions and expert
              consultation. With the help of novel technology, we grow
              businesses, improving their competitive edge. TekRevol focuses on
              empowering enterprises with state-of-the-art, user-friendly
              software solutions, easing the way for considerable revenue
              growth.
            </p>
            <p>
              Board on your digital journey with us today. Let's reform
              industries and set your business apart in the digital arena.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connects!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
